import { SENSOR_SIGNAL_TYPE } from "@shared/constants";

import { Hospital } from "./Hospital";
import { Station } from "./Station";

export enum SensorParameter {
  HR = "Heart Rate",
  RR = "Respiratory Rate",
}

export enum SensorDataScale {
  SECOND = "second",
  MINUTE = "minute",
  HOUR = "hour",
  DAY = "day",
}

export interface SensorData {
  id: number;
  sensor_id: number;
  time: Date;
  value?: number;
  reference: number;
  is_scale_data_generated: boolean;
  artifact: number;
  scale: string;
  signal_type: SENSOR_SIGNAL_TYPE;
}

export interface ResultSensorData {
  ids: number[];
  sensor_id: number;
  time: Date;
  value?: number;
  reference: number;
  artifact: number;
  signal_type: SENSOR_SIGNAL_TYPE;
}

export interface SensorChartData extends Omit<SensorData | ResultSensorData, "value" | "time"> {
  artifactValue?: number | null;
  value?: number | null;
  time: number;
}

export interface SensorListItem {
  id: number;
  sensor_code: string;
  station_id: number;
  parameter: SensorParameter;
  type: string;
  firmware_version: string | null;
  last_seen_at: Date | null;
  is_active: boolean;

  station: Partial<Station>;
  hospital: Partial<Hospital>;

  created_at: Date;
  updated_at: Date;
  updated_by: string | null;
  created_by: string | null;

  color?: string;
}
export interface Sensor extends SensorListItem {
  values: SensorData[];
}
